import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '0 24px',
  },
}))

const ContentWrapper: React.FC = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.wrapper}>{children}</div>
}

export default ContentWrapper
